import styled from "styled-components";

import { DEFAULT_MARGIN_L, DEFAULT_MARGIN_XXL } from "@src/common/styles/const";
import { media } from "@src/common/styles/mixins";
import { BoxWrapper } from "@src/modules/DeviceStatus/Devices/DeviceInfoView/shared/components";
import { Panel } from "@src/modules/shared/components/Panel/components";

export const ViewerStudyResultsPanel = styled(Panel)`
  gap: ${DEFAULT_MARGIN_XXL}px;
  margin-bottom: ${DEFAULT_MARGIN_L}px;
`;

export const ViewerResultsHeader = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const ViewerStudyResultsWrapper = styled.div`
  display: flex;
  gap: ${DEFAULT_MARGIN_L}px;

  ${media.down("MOBILE")`
    flex-wrap: wrap;
    gap: ${DEFAULT_MARGIN_L}px;
  `}
`;

export const ViewerTilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  max-width: 500px;
`;

export const CenterResultsWrapper = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ViewerResultsWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  ${BoxWrapper} {
    padding: 0;
  }
`;

export const ResultsHeader = styled.div`
  display: flex;
  flex-direction: column;
`;
